export const ACCOUNT_TYPE_STYLES = {
  EXHIBITOR: {
    intlId: "EXHIBITOR",
    color: "#068ec3",
    backgroundColor: "#e6f7fd",
  },
  SPONSOR_WITHOUT_M2: {
    intlId: "SPONSOR_WITHOUT_M2",
    color: "#7c3aed",
    backgroundColor: "#f3e8ff",
  },
  DIGITAL_ONLY: {
    intlId: "DIGITAL_ONLY",
    color: "#0d9488",
    backgroundColor: "#e6fffa",
  },
  SERVICE_PROVIDER: {
    intlId: "SERVICE_PROVIDER",
    color: "#c2410c",
    backgroundColor: "#fff1e6",
  },
};
